// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2ILdj","title":"InfoRow_title__m1M4s"};